import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=16b1d9d6&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1d9d6",
  null
  
)

export default component.exports